import { Injectable } from '@angular/core';
import { Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class OpenGraphService {
  private openGraphMetaCollection: Pick<
    MetaDefinition,
    'content' | 'property'
  >[];

  constructor(private readonly meta: Meta) {}

  public removeMeta(): void {
    this.openGraphMetaCollection?.forEach((openGraphMeta) => {
      this.meta.removeTag(`property="${openGraphMeta.property}"`);
    });
  }

  public setMeta(
    openGraphMetaCollection: Pick<MetaDefinition, 'content' | 'property'>[]
  ): void {
    this.openGraphMetaCollection = openGraphMetaCollection;

    this.meta.addTags(openGraphMetaCollection);
  }
}
